{
  "nav": {
    "home": "Inicio",
    "tutorials": "Tutoriales",
    "barcodes": "Códigos de barras",
    "contact": "Contactanos",
    "logout": "Logout",
    "logoAlt": "DinLabel",
    "download": "Descargar",
    "downloadDemo": "Descargar demo",
    "buy": "Suscribirse",
    "login": "Iniciar sesión",
    "myAccount": "Mi cuenta",
    "language": "Idioma",
    "distributorPortal": "Portal de distribuidores"
  },
  "language": {
    "title": "Idioma",
    "description": "Elige el idioma de la aplicación. Por defecto se usa el idioma del navegador.",
    "browser": "Usar idioma del navegador",
    "english": "Inglés",
    "spanish": "Español",
    "german": "Alemán",
    "french": "Francés"
  },
  "offline": {
    "title": "Sin conexión",
    "message": "La aplicación no se puede conectar con el servidor :( !!"
  },
  "dialogs": {
    "apiError": "Error de Api",
    "confirmYes": "Sí",
    "cancel": "Cancelar",
    "send": "Enviar"
  },
  "portal": {
    "pageTitle": "Portal de distribuidores",
    "actions": "Acciones",
    "authorized": "Autorizado",
    "pending": "Pendiente de aprobación",
    "buyLicenses": "Comprar licencias",
    "pendingApproval": "Su solicitud de distribuidor todavia no ha sido aprobada - para cualquier pregunta, puede contactar a {{email}}. Este proceso no debe tardar más de 2 dias habiles.",
    "distributorInfo": "Información para distribuidores",
    "loading": "Cargando información de distribuidor…",
    "loadError": "No se pudo cargar la información de distribuidor."
  },
  "licenses": {
    "noneAvailable": "Actualmente, usted no tiene licencias disponibles para enviar.",
    "statAvailable": "Disponibles para enviar",
    "statBought": "Compradas",
    "statSent": "Enviadas",
    "sentHistory": "Licencias enviadas",
    "activatedYes": "Activada",
    "buyTitle": "Portal de Distribuidores - Comprar licencias",
    "buyLoading": "Cargando…",
    "buyLoadError": "No se pudo cargar la información de distribuidor.",
    "buyIntro": "Especifique cuantas licencias desea comprar - el precio de venta a distribuidores es de {{price}} pesos. Los distribuidores pueden vender DinLabel de la manera que consideren apropiada, pero nuestro precio recomendado es de {{recommended}} pesos.",
    "licenseCountLabel": "Número de licencias",
    "costSummary": "El costo de {{count}} licencias es de {{cost}} pesos + impuestos.",
    "buyButton": "Comprar {{count}} licencias",
    "sendTitle": "Enviar licencia",
    "resendConfirm": "Deseas reenviar la licencia a {{email}}?",
    "sendPrompt": "Ingresa el correo al que deseas enviar",
    "emailPlaceholder": "correo@ejemplo.com",
    "errorTitle": "Error!",
    "sendError": "Hubo un error al enviar la licencia {{error}}",
    "resentTitle": "Licencia reenviada!",
    "resentMessage": "La licencia ha sido reenviada a {{email}} con copia a {{cc}}",
    "sentTitle": "Licencia enviada!",
    "sentMessage": "La licencia ha sido enviada a {{email}} con copia a {{cc}}",
    "sendToEmail": "Enviar licencia a correo...",
    "recipient": "Recipiente de licencia",
    "date": "Fecha",
    "sent": "Enviada",
    "activated": "Activada",
    "notActivated": "Aún no activada",
    "resend": "Reenviar licencia"
  },
  "register": {
    "title": "Conviértete en distribuidor",
    "intro": "Para acceder al portal de distribuidores DinLabel, debe primero registrarse:",
    "company": "Empresa",
    "companyPlaceholder": "Nombre de empresa",
    "phone": "Teléfono",
    "phonePlaceholder": "Telefono",
    "phoneDescription": "Asegurese de incluir el código de su pais, por ejemplo +52 8183...",
    "street": "Calle",
    "street1Placeholder": "Calle1",
    "street2Placeholder": "Calle2",
    "number": "Número",
    "city": "Ciudad",
    "state": "Estado",
    "country": "País",
    "zip": "Código postal",
    "rfc": "RFC",
    "nextSteps": "Recibira un correo con los suguientes pasos",
    "submit": "Submit"
  },
  "faq": {
    "qGoogleAccount": "¿Necesito una cuenta de Google para ser distribuidor de DINLabel?",
    "aGoogleAccount": "Si es necesario que tengas una cuenta de Google, si ya cuentas con una la puedes usar para ingresar al portal de distribuidores.",
    "qRequirements": "¿Qué necesito para ser distribuidor de DINLabel?",
    "aRequirementsBefore": "Registrarte como distribuidor en el",
    "aRequirementsLink": "portal de distribuidores",
    "aRequirementsAfter": "y esperar a recibir el correo de confirmación autorizándote como distribuidor de DINLabel.",
    "qAnyoneCanSell": "¿Cualquier persona o empresa puede vender DINLabel?",
    "aAnyoneCanSell": "Si, solo debe registrarse en el portal de distribuidores de DINLabel y recibir el correo de confirmación.",
    "qHowManyDistributors": "¿Cuántos distribuidores puede haber en DINLabel?",
    "aHowManyDistributors": "No hay límite.",
    "qDistributorCost": "¿Cuánto le cuesta a un distribuidor una licencia de DINLabel?",
    "aDistributorCost": "112 dlls mas impuestos por cada licencia.",
    "qRecommendedPrice": "¿Cuál es el precio recomendado de venta del distribuidor a sus clientes por una licencia de DINLabel?",
    "aRecommendedPrice": "El precio lo define el distribuidor, no hay un precio establecido, sugerimos un precio de venta de 160 dlls mas impuestos. Los clientes directos en el portal de DinLabel se suscriben por 15 USD al mes más impuestos.",
    "qWhereToBuy": "¿Dónde puede obtener DinLabel un usuario final?",
    "aWhereToBuyBefore": "Los clientes nuevos se suscriben mensualmente en la página de suscripción, o reciben una licencia de un distribuidor. Quienes ya compraron una vez conservan acceso de por vida. Suscríbete en el portal",
    "qHowBuyAsDistributor": "¿Como distribuidor, como compro licencias de DINLabel?",
    "aHowBuyAsDistributorBefore": "A través del Portal de distribuidores, accediendo a la sección Comprar Licencias, consulta el tutorial",
    "aHowBuyAsDistributorLink": "como comprar licencias.",
    "qMinimumLicenses": "Como distribuidor, al comprar licencias para luego venderlas a mis clientes ¿Cuál es el mínimo de licencias que debo comprar?",
    "aMinimumLicenses": "No hay un mínimo, se puede comprar desde 1 licencia.",
    "qHowDeliver": "Como Distribuidor, ¿como le entrego a mi cliente una licencia de DINLabel?",
    "aHowDeliverBefore": "A través del portal de distribuidores, en la sección de",
    "aHowDeliverSendLink": "enviar licencias",
    "aHowDeliverMiddle": ", consulte el",
    "aHowDeliverTutorialLink": "tutorial de como enviar licencias.",
    "qHowLongPurchase": "¿Cuánto tiempo toma comprar una licencia como distribuidor y entregarla al cliente?",
    "aHowLongPurchase": "Si ya estás registrado como distribuidor en cuestión de minutos se puede hacer la compra y el envío de la licencia.",
    "qHowLongToSell": "Como distribuidor, ¿Cuánto tiempo tengo para vender las licencias que adquiera en el portal?",
    "aHowLongToSell": "Las licencias del distribuidor no caducan, al comprar licencias se agregan al inventario de licencias del distribuidor y se puede disponer de ellas en cualquier momento.",
    "qHowManyAvailable": "¿Cómo puedo saber cuantas licencias tengo como distribuidor?",
    "aHowManyAvailableBefore": "Al ingresar al",
    "aHowManyAvailableLink": "portal de distribuidores",
    "aHowManyAvailableAfter": "de DINLabel, en la primera pantalla te mostrará tu saldo de licencias disponibles para enviar.",
    "qSoldLicenses": "¿Cómo puedo saber qué licencias he vendido y a quien se las he vendido?",
    "aSoldLicensesBefore": "A través del portal de distribuidores de DINLabel en la sección",
    "aSoldLicensesLink": "ver detalles",
    "qTryBefore": "¿Puedo probar DINLabel antes de hacerme distribuidor?",
    "aTryBeforeBefore": "Si, puedes descargar una Demo en",
    "aTryBeforeAfter": "y probarla.",
    "qMainFaq": "¿Hay FAQ’s (preguntas frecuentes) para consultar en el portal DINLabel?",
    "aMainFaqBefore": "En",
    "aMainFaqAfter": "encontrarás las pregutas mas frequentes sobre el uso del sistema DINLabel.",
    "qTutorials": "¿Hay tutoriales para el uso del DINLabel?",
    "aTutorialsBefore": "En",
    "aTutorialsAfter": "encontrarás todos los tutoriales necesarios para el uso del DINLabel.",
    "qSupport": "¿Como distribuidor, tengo soporte técnico?",
    "aSupport": "Por correo electrónico, ver el final de estas FAQ.",
    "qOtherQuestion": "Tengo una duda y no se encuentra en la lista. ¿Qué puedo hacer?",
    "aOtherQuestionBefore": "Nos encantaría ayudarte. Ir a",
    "aOtherQuestionLink": "contáctanos",
    "aOtherQuestionAfter": ", envía tus dudas y con gusto te respondemos."
  },
  "tutorials": {
    "title": "Tutoriales",
    "alsoSeeFaqBefore": "Tambien puede ver la página de",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: Como enviar una licencia desde el portal de distribuidores",
    "iframeTitle": "Tutorial enviar licencia"
  },
  "home": {
    "welcome": "Bienvenid@, {{email}}",
    "error": "Error"
  },
  "userLicenses": {
    "hasLicense": "Ya tienes acceso completo a DinLabel.",
    "hasSubscription": "Tu suscripción de DinLabel está activa.",
    "manageBilling": "Administrar facturación",
    "noLicense": "No tienes una suscripción activa de DinLabel",
    "buyHere": "Suscríbete aquí"
  },
  "signin": {
    "title": "Iniciar sesión",
    "intro": "Inicia sesión con Google o con tu correo y contraseña para continuar.",
    "withGoogle": "Iniciar sesión con Google",
    "orEmail": "o",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "withEmail": "Iniciar sesión con correo",
    "createAccount": "Crear una cuenta",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "emailPasswordError": "No se pudo iniciar sesión. Revisa tu correo y contraseña.",
    "agreePrefix": "Al continuar aceptas nuestra",
    "privacyLink": "Política de privacidad y términos de servicio",
    "alreadySignedIn": "Ya has iniciado sesión",
    "signedInAs": "Sesión iniciada como {{email}}",
    "continue": "Continuar",
    "debugSignInUrl": "URL de inicio de sesión"
  },
  "registerAccount": {
    "title": "Crear una cuenta",
    "intro": "Regístrate con tu correo y una contraseña.",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "passwordHint": "Al menos 8 caracteres",
    "submit": "Crear cuenta",
    "haveAccount": "¿Ya tienes una cuenta?",
    "signIn": "Iniciar sesión",
    "error": "No se pudo crear la cuenta.",
    "googleExists": "Este correo ya está registrado con Google. Inicia sesión con Google y luego agrega una contraseña en Mi cuenta si quieres."
  },
  "forgotPassword": {
    "title": "Olvidé mi contraseña",
    "intro": "Escribe tu correo y te enviaremos un enlace de restablecimiento si existe una cuenta.",
    "email": "Correo electrónico",
    "submit": "Enviar enlace",
    "sent": "Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento.",
    "backToSignIn": "Volver a iniciar sesión",
    "error": "No se pudo enviar el correo de restablecimiento."
  },
  "resetPassword": {
    "title": "Restablecer contraseña",
    "password": "Nueva contraseña",
    "passwordHint": "Al menos 8 caracteres",
    "submit": "Actualizar contraseña",
    "success": "Tu contraseña ha sido actualizada.",
    "signIn": "Iniciar sesión",
    "backToSignIn": "Volver a iniciar sesión",
    "invalidLink": "Este enlace de restablecimiento no es válido o está incompleto.",
    "error": "No se pudo restablecer la contraseña."
  },
  "applogin": {
    "title": "Continuar en DinLabel",
    "intro": "Continúa para terminar de iniciar sesión en la aplicación de escritorio.",
    "signedInAs": "Has iniciado sesión como {{email}}.",
    "continue": "Continuar",
    "switchAccount": "Usar otra cuenta",
    "redirecting": "Redirigiendo al inicio de sesión…",
    "invalidTitle": "Enlace de inicio de sesión no válido",
    "invalidBody": "Esta página la abre la aplicación de escritorio DinLabel. Inicia sesión desde la aplicación."
  },
  "marketing": {
    "headline": "Software profesional para la gestión e impresión de etiquetas",
    "slogan": "Configura e imprime fácilmente en impresoras térmicas (Zebra y más), láser e inyección. Agrega textos, códigos de barras, datos variables y numeración consecutiva en etiquetas de tela, cartulina o adhesivas.",
    "featureNumbers": "Numeración consecutiva y contadores",
    "featureImages": "Logos e imágenes nítidas",
    "featureVariable": "Datos variables sin complicaciones",
    "featureQr": "Códigos QR interactivos",
    "featureText": "Texto claro y legible",
    "featureBarcode": "Códigos de barras profesionales",
    "featureDemo": {
      "productName": "Nombre del producto",
      "oliveOil": "Aceite de Oliva",
      "oliveOilDesc": "Descripción del aceite de oliva",
      "fontsNote": "Fuentes claras y finas legibles",
      "sequence": "Secuencia {{n}}",
      "client": "CLIENTE:",
      "name": "Nombre",
      "city": "CIUDAD:",
      "companyLogo": "Logo de empresa"
    },
    "featuresTitle": "Todo lo que necesitas en una etiqueta",
    "featuresSubtitle": "Crea etiquetas profesionales con las herramientas que usan imprentas y almacenes cada día.",
    "seeBarcodeTypes": "Ver tipos de código de barras compatibles",
    "printersTitle": "Compatible con cualquier impresora",
    "printersSubtitle": "DinLabel se conecta directamente a las impresoras que ya usas en tu negocio mediante los controladores estándar de Windows.",
    "printersTypesTitle": "Tipos de impresoras y soportes:",
    "printersThermalLabel": "Térmicas y Transferencia Térmica:",
    "printersThermalBody": "Ideales para etiquetas en rollo adhesivas, tyvek, nylon, cartón etc.",
    "printersLaserLabel": "Láser e Inyección de Tinta (Inkjet):",
    "printersLaserBody": "Ideales para planillas de hojas adhesivas, de cartón o tela.",
    "whyTitle": "¿Por qué DinLabel?",
    "whyCompatLabel": "Compatibilidad total:",
    "whyCompatBody": "Imprime en cualquier impresora (térmica, láser e inkjet) en rollos o planillas.",
    "whyCostLabel": "Sin costos inflados:",
    "whyCostBody": "Todas las funciones profesionales sin pagar licencias empresariales carísimas.",
    "whySupportLabel": "Soporte técnico real:",
    "whySupportBody": "Te ayudamos paso a paso desde que lo descargas, lo instalas y empiezas a imprimir tus etiquetas.",
    "tryTitle": "Prueba DinLabel gratis hoy mismo",
    "trySubtitle": "Descarga la versión demo gratuita, conecta la impresora que tengas (térmica, láser e inkjet) y comprueba cómo imprime tus etiquetas en minutos.",
    "needHelp": "¿Necesitas ayuda?",
    "customerService": "Servicio al cliente",
    "customerServiceText": "Contáctanos por correo y con gusto te ayudamos.",
    "tutorialsText": "Tutoriales en video paso a paso para cada función."
  },
  "barcodes": {
    "title": "Tipos de código de barras en DinLabel",
    "intro": "DinLabel imprime los tipos de código de barras más usados en etiquetas de retail, envío e industria. Los tipos de abajo aparecen primero al agregar un código de barras. Elige Mostrar más en el editor para usar cualquiera de los tipos adicionales que soportamos.",
    "commonTitle": "Tipos de código de barras más comunes",
    "commonIntro": "Estos son los tipos que recomendamos para la mayoría de las etiquetas. DinLabel los incluye desde el inicio.",
    "fullTitle": "Todos los tipos de código de barras compatibles",
    "fullIntro": "El editor de códigos de barras muestra estos nombres cuando eliges Mostrar más. Usa en DinLabel el mismo nombre que ves aquí.",
    "fullCount": "DinLabel admite {{count}} tipos de código de barras.",
    "ctaInstall": "Descargar DinLabel",
    "ctaTutorials": "Ver tutoriales de códigos de barras",
    "common": {
      "UpcA": {
        "name": "UPC-A",
        "description": "El código de 12 dígitos en la mayoría de los productos que se venden en Norteamérica."
      },
      "UpcE": {
        "name": "UPC-E",
        "description": "Un UPC compacto de 6 dígitos para empaques pequeños que no caben UPC-A."
      },
      "Ean13": {
        "name": "EAN-13",
        "description": "El código de barras de 13 dígitos usado en todo el mundo, incluso en Europa y América Latina."
      },
      "Ean8": {
        "name": "EAN-8",
        "description": "Un EAN más corto para productos pequeños que no caben EAN-13."
      },
      "Code128": {
        "name": "Code 128",
        "description": "Un código lineal de alta densidad para letras, números y símbolos. Común en envíos e inventario."
      },
      "GS1128": {
        "name": "GS1-128",
        "description": "Code 128 con identificadores de aplicación GS1 para logística, GTIN, lote y fechas."
      },
      "Code39": {
        "name": "Code 39",
        "description": "Un código industrial muy usado que codifica letras, números y algunos símbolos."
      },
      "Interleaved2of5": {
        "name": "Interleaved 2 de 5",
        "description": "Un código numérico compacto usado en almacenes, distribución y etiquetas industriales."
      },
      "Itf14": {
        "name": "ITF-14",
        "description": "Un código de 14 dígitos para cajas de envío y empaques exteriores (GTIN-14)."
      },
      "QRCode": {
        "name": "Código QR",
        "description": "Un código 2D que guarda URL, texto y más. Fácil de escanear con el teléfono."
      },
      "DataMatrix": {
        "name": "Data Matrix",
        "description": "Un código 2D compacto usado en electrónica, salud y marcado de piezas pequeñas."
      },
      "Pdf417": {
        "name": "PDF417",
        "description": "Un código 2D apilado que guarda más datos que un código 1D típico, usado en identificaciones, envíos y boletos."
      }
    }
  },
  "footer": {
    "tagline": "Diseño profesional de etiquetas para impresoras térmicas — Zebra y más.",
    "privacy": "Privacidad y términos",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Descargar",
    "intro": "Instala DinLabel en Windows y empieza a diseñar etiquetas para impresoras térmicas — incluyendo Zebra y otras impresoras de etiquetas Windows — en minutos.",
    "windowsNote": "Instalador de Windows (.exe). Compatible con Windows 7 y posteriores.",
    "requirements": "Requisitos del sistema",
    "reqWindows": "Compatible con cualquier version de Windows a partir de Windows 7",
    "reqInternet": "Acceso a Internet",
    "reqDisk": "50 MB de espacio disponible en disco duro",
    "freeTag": "Versión demo",
    "freeText": "La versión demo incluye una marca de agua en las etiquetas impresas.",
    "paidTitle": "Versión completa",
    "paidText": "Sin marcas de agua — lista para impresión de producción.",
    "buyApp": "Suscribirse a DinLabel",
    "orDistributor": "¿Prefieres suscribirte a través de un socio?",
    "distributorsLink": "Ver distribuidores",
    "emailModalTitle": "Descargar la demo",
    "emailModalIntro": "Introduce tu correo electrónico para descargar la demo de DinLabel.",
    "emailLabel": "Correo electrónico",
    "emailSubmit": "Descargar",
    "emailInvalid": "Introduce una dirección de correo válida.",
    "emailSubmitError": "Algo salió mal. Inténtalo de nuevo.",
    "purchasedIntro": "Descarga e instala DinLabel para empezar a usar tu versión completa.",
    "signInTitle": "Cómo iniciar sesión",
    "signInStep1": "Descarga e instala DinLabel con el botón de arriba.",
    "signInStep2": "Abre DinLabel.",
    "signInStep3": "Elige Iniciar sesión / registrarse en el menú.",
    "signInStep4": "Inicia sesión con la misma cuenta que usaste para suscribirte. Una vez iniciada la sesión, estarás usando la versión completa de DinLabel.",
    "signInStep4UnpurchasedBefore": "Inicia sesión con una cuenta. Usarás la versión demo",
    "signInStep4UnpurchasedLink": "hasta que te suscribas",
    "signInStep4UnpurchasedAfter": "."
  },
  "fullTutorials": {
    "title": "Tutoriales",
    "intro": "Videos paso a paso para diseñar, imprimir y aprovechar DinLabel al máximo.",
    "howToRoll": "Cómo crear una etiqueta en rollo",
    "howToSheet": "Cómo crear una etiqueta en planilla",
    "howTo3Across": "Cómo crear etiquetas de 3 al paso",
    "howToText": "Cómo agregar texto",
    "howToShapes": "Cómo agregar figuras",
    "howToImages": "Cómo agregar imágenes",
    "howToBarCodes": "Cómo agregar códigos de barras",
    "howToQR": "Cómo agregar códigos QR",
    "howToPrint": "Cómo imprimir",
    "howToConsecutive": "Cómo usar números consecutivos",
    "howToDataBase": "Cómo usar bases de datos",
    "howToBuy": "Cómo suscribirse a DinLabel",
    "alsoDistributor": "Los tutoriales para distribuidores están en el portal de distribuidores.",
    "distributorLink": "Abrir portal de distribuidores"
  },
  "privacy": {
    "title": "Política de privacidad y términos de servicio",
    "eulaLink": "Contrato de licencia de usuario final",
    "policyLink": "Política de privacidad",
    "note": "La política de privacidad abre el documento HTML estático localizado.",
    "loading": "Cargando…",
    "eulaLoadError": "No se pudo cargar el EULA."
  },
  "distributors": {
    "title": "Distribuidores"
  },
  "buyPage": {
    "title": "Suscribirse a DinLabel",
    "intro": "Desbloquea la versión completa con una suscripción mensual — sin marcas de agua, lista para impresión térmica y de producción en Zebra y otras impresoras de etiquetas.",
    "panelTitle": "Suscripción mensual",
    "errorTitle": "Algo salió mal",
    "thanks": "Gracias por suscribirte a DinLabel. ¡Ya tienes acceso completo a la aplicación!",
    "thanksLifetime": "Gracias — ya tienes acceso de por vida a DinLabel.",
    "checkAccount": "Revisa el estado de tu cuenta",
    "goToDownload": "Ir a la página de descarga",
    "manageBilling": "Administrar facturación",
    "price": "USD ${{price}}/mes + Impuestos",
    "payWithCard": "Suscribirse con tarjeta",
    "payError": "No se pudo redirigir a Stripe.",
    "adminTestMode": "Este es un usuario administrador, por lo que el checkout usará información de testmode. Usa la tarjeta '4242 4242 4242 4242'.",
    "debugToggleBought": "Solo para admins: Debug: Alternar Bought",
    "toggleBoughtError": "No se pudo alternar el estado de compra.",
    "orVia": "¿Prefieres otra opción?",
    "downloadDemo": "Descargar una demo completamente funcional"
  },
  "userInfo": {
    "title": "Mi cuenta",
    "detailsTitle": "Datos de la cuenta",
    "quickLinks": "Enlaces rápidos",
    "userId": "ID de usuario",
    "email": "Correo electrónico",
    "emailConfirmed": "Correo confirmado",
    "confirmed": "Confirmado",
    "notConfirmed": "Sin confirmar",
    "resend": "Reenviar",
    "resentEmail": "Correo de confirmación reenviado a {{email}}",
    "resendError": "No se pudo reenviar el correo de confirmación.",
    "version": "Versión de la aplicación",
    "freeVersion": "Versión demo",
    "fullVersion": "Versión completa",
    "lifetimeAccess": "Acceso de por vida",
    "subscription": "Suscripción",
    "subscriptionTitle": "Suscripción",
    "subscriptionStatus": "Estado",
    "subscriptionRenews": "Se renueva el",
    "subscriptionEnds": "Acceso hasta",
    "subscriptionCancelScheduled": "Se cancela al final del periodo",
    "subscriptionLoading": "Cargando suscripción…",
    "subscriptionError": "No se pudo cargar el estado de la suscripción.",
    "manageBilling": "Administrar facturación",
    "statusActive": "Activa",
    "statusTrialing": "Prueba",
    "statusPastDue": "Pago atrasado",
    "statusCanceled": "Cancelada",
    "statusUnpaid": "Impaga",
    "statusIncomplete": "Incompleta",
    "statusIncompleteExpired": "Vencida",
    "statusPaused": "Pausada",
    "statusUnknown": "{{status}}",
    "buyApp": "Suscribirse",
    "accountType": "Cuenta",
    "admin": "Portal de administración",
    "openDistributorPortal": "Abrir portal de distribuidores",
    "setPasswordTitle": "Agregar contraseña",
    "setPasswordIntro": "Agrega una contraseña para iniciar sesión con correo además de Google. Tu cuenta y licencia no cambian.",
    "changePasswordTitle": "Cambiar contraseña",
    "changePasswordIntro": "Actualiza la contraseña del inicio de sesión con correo.",
    "confirmEmailBeforePassword": "Confirma tu correo antes de agregar una contraseña.",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "passwordHint": "Al menos 8 caracteres",
    "setPasswordExpand": "Agregar contraseña",
    "changePasswordExpand": "Cambiar contraseña",
    "passwordFormCancel": "Cancelar",
    "setPasswordSubmit": "Guardar contraseña",
    "changePasswordSubmit": "Actualizar contraseña",
    "passwordSet": "Contraseña guardada. Ya puedes iniciar sesión con correo y contraseña.",
    "passwordChanged": "Contraseña actualizada.",
    "passwordError": "No se pudo actualizar la contraseña."
  },
  "myLabels": {
    "title": "Mis etiquetas",
    "loading": "Cargando…",
    "loadError": "No se pudieron cargar las etiquetas.",
    "empty": "No tienes etiquetas guardadas.",
    "name": "Nombre",
    "date": "Fecha",
    "view": "Ver",
    "download": "Descargar",
    "back": "Volver a mis etiquetas"
  },
  "admin": {
    "title": "Portal de administración",
    "dataLink": "Panel de análisis de clientes DinLabel",
    "serverAnalyticsLink": "Panel de análisis del servidor",
    "fakeEmailLink": "Correos falsos",
    "loading": "Cargando…",
    "loadError": "No se pudieron cargar los datos de administración.",
    "totalUsers": "Usuarios totales: {{count}}",
    "paidUsers": "Usuarios de pago: {{count}}",
    "totalSubscribedUsers": "Total de usuarios suscritos: {{count}}",
    "users": "Usuarios",
    "distributors": "Distribuidores",
    "payments": "Pagos de distribuidores",
    "demoDownloaders": "Descargas de demo",
    "authorize": "Autorizar",
    "toggleAdmin": "Alternar admin"
  },
  "fakeEmail": {
    "title": "Correos falsos",
    "description": "Vista previa de plantillas de correo con datos de ejemplo.",
    "distributorSignUp": "Registro de distribuidor",
    "activationLink": "Activación / confirmar correo",
    "sendEmailLicense": "Distribuidor envía licencia",
    "congratulationEmail": "Felicitaciones",
    "boughtLicensesMail": "Licencias compradas",
    "demoDownloadThankYou": "Agradecimiento por demo",
    "subject": "Asunto",
    "body": "Cuerpo",
    "loading": "Cargando…",
    "loadError": "No se pudo cargar este correo.",
    "backAdmin": "Volver a administración",
    "testAddress": "Dirección de prueba",
    "testAddressPlaceholder": "tu@ejemplo.com",
    "sendTest": "Enviar prueba",
    "sendSuccess": "Se envió {{action}} a {{email}}",
    "sendError": "No se pudo enviar el correo de prueba."
  }
}
